import { t } from "i18next";
import React from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import OutsideClickHandler from "react-outside-click-handler";
import ConditionalOutsideClick from "../../component/ConditionalOutsideClick";
const Profile = () => {
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const navigate = useNavigate();
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />{" "}
        <ConditionalOutsideClick onOutsideClick={() => navigate(-1)}>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page__main popup-page-main popup-page-main--show"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__header"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__title"
              >
                {t("PersonalInformation")}
              </div>
              <div
                onClick={() => navigate("/")}
                _ngcontent-serverapp-c2790459173
                className="popup-page-main__close ng-star-inserted"
              />
            </div>
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__container"
            >
              <div
                _ngcontent-serverapp-c2790459173
                className="content player-content"
              >
                <ng-component
                  _nghost-serverapp-c8985285
                  className="ng-tns-c8985285-27 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c8985285
                    className="info-top-type ng-tns-c8985285-27 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c8985285
                      className="player-info ng-tns-c8985285-27 ng-star-inserted"
                    >
                      <video
                        _ngcontent-serverapp-c8985285
                        drccdnvideo
                        width="100%"
                        height="100%"
                        autoPlay
                        playsInline
                        loop
                        drccdnsrc="/assets/images/vip/member.png"
                        className="ng-tns-c8985285-27 ng-star-inserted"
                        poster="/assets/Other/member.png"
                      >
                        <source
                          _ngcontent-serverapp-c8985285
                          drccdnsrc="/assets/images/vip/member.mov"
                          type="video/quicktime"
                          className="ng-tns-c8985285-27"
                          src="/assets/Other/member.mov"
                        />
                        <source
                          _ngcontent-serverapp-c8985285
                          drccdnsrc="/assets/images/vip/member.webm"
                          type="video/webm"
                          className="ng-tns-c8985285-27"
                          src="/assets/Other/member.webm"
                        />
                      </video>
                    </div>

                    <div
                      _ngcontent-serverapp-c8985285
                      className="membername-wrap ng-tns-c8985285-27"
                    >
                      <div
                        _ngcontent-serverapp-c8985285
                        className="membername ng-tns-c8985285-27 ng-star-inserted"
                      >
                        {user?.user?.username}
                      </div>
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c8985285
                    className="menu-box ng-tns-c8985285-27 ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c8985285
                      className="input-group personal-phone-group ng-tns-c8985285-27"
                    >
                      <label
                        _ngcontent-serverapp-c8985285
                        htmlFor="other"
                        className="ng-tns-c8985285-27"
                      >
                        {t("MobileNumber")}
                      </label>
                      <div
                        _ngcontent-serverapp-c8985285
                        className="input-wrap ng-tns-c8985285-27 ng-star-inserted"
                      >
                        <input
                          _ngcontent-serverapp-c8985285
                          type="text"
                          disabled
                          className="personal-number ng-tns-c8985285-27 default"
                          defaultValue={profileData?.phone}
                        />
                      </div>
                    </div>
                    {/* <div
                      _ngcontent-serverapp-c8985285
                      className="input-group personal-phone-group ng-tns-c8985285-27"
                    >
                      <label
                        _ngcontent-serverapp-c8985285
                        htmlFor="other"
                        className="ng-tns-c8985285-27"
                      >
                        Upline Mobile Number
                      </label>
                      <div
                        _ngcontent-serverapp-c8985285
                        className="input-wrap ng-tns-c8985285-27 ng-star-inserted"
                      >
                        <input
                          _ngcontent-serverapp-c8985285
                          type="text"
                          disabled
                          className="personal-number ng-tns-c8985285-27 default"
                          defaultValue={profileData.uplineData?.phone}
                        />
                      </div>
                    </div>{" "} */}
                    <div
                      _ngcontent-serverapp-c8985285
                      className="input-group personal-phone-group ng-tns-c8985285-27"
                    >
                      <label
                        _ngcontent-serverapp-c8985285
                        htmlFor="other"
                        className="ng-tns-c8985285-27"
                      >
                        {t("Password")}
                      </label>
                      <div
                        _ngcontent-serverapp-c8985285
                        className="input-wrap ng-tns-c8985285-27 ng-star-inserted"
                      >
                        <input
                          _ngcontent-serverapp-c8985285
                          type="password"
                          disabled
                          className="personal-number ng-tns-c8985285-27 default"
                          defaultValue={"********"}
                        />
                        <div
                          onClick={() => navigate("/reset-password")}
                          style={{ color: "white" }}
                          class="status save-btn ng-tns-c8985285-27"
                        >
                          {t("Edit")}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-component>
              </div>
            </div>
          </div>
        </ConditionalOutsideClick>
      </div>
    </app-popup-page>,
    document.getElementById("overlay"),
  );
};

export default Profile;
